import React from 'react';

export default function BookingsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M16.3636 1.81818H15.4545V0H13.6364V1.81818H4.54545V0H2.72727V1.81818H1.81818C0.818182 1.81818 0 2.63636 0 3.63636V18.1818C0 19.1818 0.818182 20 1.81818 20H16.3636C17.3636 20 18.1818 19.1818 18.1818 18.1818V3.63636C18.1818 2.63636 17.3636 1.81818 16.3636 1.81818ZM16.3636 18.1818H1.81818V6.36364H16.3636V18.1818Z"
      />
    </svg>
  );
}
